function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import IlcEvents from '../constants/ilcEvents';
import { BaseError, UnhandledError, FetchTemplateError, CriticalRuntimeError, CriticalInternalError } from '../errors';
var _ilcAlreadyCrashed = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
var _registryService = /*#__PURE__*/new WeakMap();
var _ErrorHandlerManager_brand = /*#__PURE__*/new WeakSet();
var ErrorHandlerManager = /*#__PURE__*/function () {
  function ErrorHandlerManager(logger, registryService) {
    _classCallCheck(this, ErrorHandlerManager);
    _classPrivateMethodInitSpec(this, _ErrorHandlerManager_brand);
    _classPrivateFieldInitSpec(this, _ilcAlreadyCrashed, false);
    _classPrivateFieldInitSpec(this, _logger, void 0);
    _classPrivateFieldInitSpec(this, _registryService, void 0);
    _classPrivateFieldSet(_logger, this, logger);
    _classPrivateFieldSet(_registryService, this, registryService);
  }
  return _createClass(ErrorHandlerManager, [{
    key: "handleError",
    value: function handleError(error) {
      if (!(error instanceof BaseError)) {
        error = new UnhandledError({
          message: error.message,
          cause: error
        });
      }

      // Ignoring all consequent errors after crash
      if (_classPrivateFieldGet(_ilcAlreadyCrashed, this)) {
        _classPrivateFieldGet(_logger, this).info("Ignoring error as we already crashed...\n".concat(error.stack));
        return;
      }
      if (_assertClassBrand(_ErrorHandlerManager_brand, this, _isCriticalError).call(this, error)) {
        _classPrivateFieldGet(_logger, this).fatal(error.message, error);
        _assertClassBrand(_ErrorHandlerManager_brand, this, _crashIlc).call(this, error);
        return;
      }
      _classPrivateFieldGet(_logger, this).error(error.message, error);
    }
  }]);
}();
function _isCriticalError(error) {
  return error instanceof CriticalInternalError || error instanceof CriticalRuntimeError;
}
function _crashIlc(error) {
  var _this = this;
  _classPrivateFieldGet(_registryService, this).getTemplate('500').then(function (data) {
    data = data.data.replace('%ERRORID%', error.errorId ? "Error ID: ".concat(error.errorId) : '');
    document.querySelector('html').innerHTML = data;
    _classPrivateFieldSet(_ilcAlreadyCrashed, _this, true);
    window.dispatchEvent(new CustomEvent(IlcEvents.CRASH));
  })["catch"](function (error) {
    var fetchTemplateError = new FetchTemplateError({
      message: 'Failed to get 500 error template',
      cause: error,
      data: {
        fragmentErrorId: error.errorId
      }
    });
    _classPrivateFieldGet(_logger, _this).error(fetchTemplateError.message, fetchTemplateError);
    alert('Something went wrong! Please try to reload page or contact support.');
  });
}
export { ErrorHandlerManager as default };